import axios from 'axios';
import { AuthService } from './AuthService';

export const postData = (url: string, data: any): Promise<any> => {
    const authService = new AuthService();
    return authService.getIDToken().then(function(response){
        const headers = {
            Authorization: 'Bearer '+  response
        }
        return axios.post(url, data, {headers}).then((response) => {
            if (response) {
                return response;
            } else {
                return Promise.reject(response);
            }
        }).catch((error) => {
            if(error.response.status == 401){
                window.location.assign('/');
            }
            return Promise.reject(error);
        });
    });  
};


export const putData = (url: string, data: any): Promise<any> => {
    const authService = new AuthService();
    return authService.getIDToken().then(function(response){
        const headers = {
            Authorization: 'Bearer '+  response
        }
        return axios.put(url, data, {headers}).then((response) => {
            if (response) {
                return response;
            } else {
                return Promise.reject(response);
            }
        }).catch((error) => {
            if(error.response.status == 401){
                window.location.assign('/');
            }
            return Promise.reject(error);
        });
    });  
};


export const getData = (url: string): Promise<any> =>{
    const authService = new AuthService();
    return authService.getIDToken().then(function(response){
        const headers = {
            Authorization: 'Bearer '+  response
        }
        return axios.get(url, {headers}).then((response)=>{
            if(response){
                return response;
            }else{
                return Promise.reject(response);
            }
        }).catch((error) => {
            if(error.response.status == 401){
                window.location.assign('/');
            }
            return Promise.reject(error);
        });
    });  
};



export const postDataFile = (url: string, data: any): Promise<any> => {
    const authService = new AuthService();
    return authService.getIDToken().then(function(response){
        const headers = {
            Authorization: 'Bearer '+  response,
            'Content-Type': 'multipart/form-data'
        }
        return axios.post(url, data, {headers}).then((response) => {
            if (response) {
                return response;
            } else {
                return Promise.reject(response);
            }
        }).catch((error) => {
            if(error.response.status == 401){
                window.location.assign('/');
            }
            return Promise.reject(error);
        });
    });  
};

export const postDataFileDownload = (url: string, data: any): Promise<any> => {
    const authService = new AuthService();
    return authService.getIDToken().then(function(response){
        const headers = {
            Authorization: 'Bearer '+  response,
            Accept: 'application/octet-stream'
        }
        return axios.post(url, data, {headers, responseType: "blob"}).then((response) => {
            if (response) {
                return response;
            } else {
                return Promise.reject(response);
            }
        }).catch((error) => {
            if(error.response.status == 401){
                window.location.assign('/');
            }
            return Promise.reject(error);
        });
    });  
};



export const getDataFileDownload = (url: string): Promise<any> => {
    const authService = new AuthService();
    return authService.getIDToken().then(function(response){
        const headers = {
            Authorization: 'Bearer '+  response,
            Accept: '*/*'
        }
        return axios.get(url, {headers, responseType: "blob"}).then((response) => {
            if (response) {
                return response;
            } else {
                return Promise.reject(response);
            }
        }).catch((error) => {
            if(error.response.status == 401){
                window.location.assign('/');
            }
            return Promise.reject(error);
        });
    });  
};